import { Auth } from "aws-amplify";
import { DEFAULT_APP_VERSION } from "../constants/login";

export async function loadUserVariant(): Promise<string> {
	try {
		if (process.env.REACT_APP_ENVIRONMENT === "OFFLINE") {
			return process.env.REACT_APP_VERSION || DEFAULT_APP_VERSION;
		}
		const user = await Auth.currentAuthenticatedUser();
		return user?.attributes?.["custom:variant"] ?? DEFAULT_APP_VERSION;
	} catch {
		return DEFAULT_APP_VERSION;
	}
}

export function normalizeVariant(v: string) {
	return (v || DEFAULT_APP_VERSION).replace(/^\/+/, "");
}
